var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodEstablishmentBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D1C4E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "#18181B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.046 8L9.5 10.91v4.363c0 4.036 2.793 7.81 6.546 8.727 3.752-.916 6.545-4.69 6.545-8.727v-4.364L16.045 8zm5.09 7.273c0 3.287-2.167 6.32-5.09 7.221-2.924-.901-5.091-3.934-5.091-7.221v-3.418l5.09-2.262 5.091 2.261v3.419zm-8.429.429l-1.025 1.025 2.909 2.91 5.818-5.819-1.025-1.032-4.793 4.792-1.884-1.876z",
    fill: "#27272A"
  })));
}
export default SvgFoodEstablishmentBadge;